import React from "react";
import { ArrowUpRight, MapPin, Clock } from "lucide-react";
import { monthShort, dayNum, timeRange } from "../lib/date";

export const EventCard = ({ event, onOpen, past = false }) => {
  return (
    <article
      data-testid={`event-card-${event.id}`}
      onClick={() => onOpen(event)}
      className={`group relative flex flex-col text-left bg-paper border border-ink/10 hover:border-ink/40 transition-colors duration-300 cursor-pointer ${
        past ? "opacity-70 hover:opacity-100" : ""
      }`}
    >
      {event.image_url ? (
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={event.image_url}
            alt={event.title}
            loading="lazy"
            className="w-full h-full object-cover grayscale-img group-hover:scale-105 transition-transform duration-700 ease-out"
          />
          <div className="absolute inset-0 bg-ink/10" />
        </div>
      ) : (
        <div className="relative aspect-[4/3] bg-ink flex items-center justify-center overflow-hidden">
          <span className="font-serif text-paper/30 text-5xl italic">TT</span>
        </div>
      )}

      <div className="p-6 md:p-7 flex flex-col flex-1">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-baseline gap-2 text-trailride">
            <span className="font-sans font-semibold text-sm tracking-widest uppercase">
              {monthShort(event.start)}
            </span>
            <span className="font-serif font-bold text-2xl leading-none">{dayNum(event.start)}</span>
          </div>
          <span className="font-sans text-[11px] tracking-[0.18em] uppercase text-ink/50 border border-ink/15 rounded-full px-3 py-1">
            {event.category}
          </span>
        </div>

        <h3 className="font-serif text-xl md:text-2xl font-semibold text-ink leading-snug mb-3">
          {event.title}
        </h3>

        <div className="font-sans text-sm text-ink/60 space-y-1.5 mb-4">
          <p className="flex items-center gap-2">
            <Clock size={14} className="shrink-0" /> {timeRange(event.start, event.end)}
          </p>
          <p className="flex items-center gap-2">
            <MapPin size={14} className="shrink-0" /> {event.location}
          </p>
        </div>

        <p className="font-sans text-sm text-ink/70 leading-relaxed line-clamp-2 mb-6">
          {event.description}
        </p>

        <div className="mt-auto">
          {past ? (
            <span className="font-sans text-xs tracking-widest uppercase text-ink/40">
              Past event
            </span>
          ) : event.tigerlink_url ? (
            <a
              href={event.tigerlink_url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              data-testid={`event-rsvp-${event.id}`}
              className="inline-flex items-center gap-1.5 font-sans text-sm font-semibold text-trailride hover:gap-2.5 transition-all"
            >
              RSVP on TigerLink <ArrowUpRight size={16} />
            </a>
          ) : null}
        </div>
      </div>
    </article>
  );
};
